import { Component } from '@theme/component';

class BarryNavigation extends Component {
  connectedCallback() { super.connectedCallback(); this.setup(); }
  updatedCallback() { super.updatedCallback(); this.cleanup(); this.setup(); }
  setup() {
    this.controller?.abort(); this.controller = new AbortController();
    const o = { signal:this.controller.signal };
    this.details=this.querySelector('details'); this.summary=this.querySelector('summary');
    this.dialog=this.querySelector('dialog'); this.content=this.querySelector('.bc-menu-content');
    if (!this.dialog || !this.content) return;
    this.summary.addEventListener('click', e=>{
      e.preventDefault(); this.dialog.querySelector('[data-menu-mount]').append(this.content);
      this.details.open=false; this.dialog.showModal();
      this.summary.setAttribute('aria-expanded','true'); document.documentElement.classList.add('bc-menu-open');
      this.content.querySelector('a')?.focus();
    },o);
    this.querySelector('[data-menu-close]').addEventListener('click',()=>this.dialog.close(),o);
    this.content.addEventListener('click',e=>{if(e.target.closest('a')) this.dialog.close();},o);
    this.dialog.addEventListener('close',()=>this.restore(),o);
    this.wide=matchMedia('(min-width:750px)');
    this.wide.addEventListener('change',()=>{if(this.wide.matches&&this.dialog.open)this.dialog.close();},o);
  }
  restore() {
    if(this.content&&this.details)this.details.append(this.content);
    this.summary?.setAttribute('aria-expanded','false');
    document.documentElement.classList.remove('bc-menu-open');
    this.summary?.focus({preventScroll:true});
  }
  cleanup() {
    if(this.dialog?.open)this.dialog.close();
    this.restore();this.controller?.abort();
  }
  disconnectedCallback(){this.cleanup();super.disconnectedCallback();}
}
if(!customElements.get('bc-navigation'))customElements.define('bc-navigation',BarryNavigation);
